import { DEFAULT_SCHEDULE_ORDER_BY } from 'common-data-handling';
import { useEventSchedule } from './useEventSchedule';

/**
 * Returns the selected sessions for a given event ID. The sessions are filtered
 * based on whether they are selectable and selected, and are sorted according
 * to the DEFAULT_SCHEDULE_ORDER_BY constant.
 *
 * @param {number} eventId - The ID of the event.
 * @return {Array} The selected sessions.
 */
export function useSelectedSessions(eventId) {
    return useEventSchedule(eventId, {
        filter: (session) => session.is_selectable && session.is_selected,
        orderBy: DEFAULT_SCHEDULE_ORDER_BY,
    });
}
